import { render, staticRenderFns } from "./JuniorMenu.vue?vue&type=template&id=360eca1e&"
import script from "./JuniorMenu.vue?vue&type=script&lang=js&"
export * from "./JuniorMenu.vue?vue&type=script&lang=js&"
import style0 from "./JuniorMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports